import { useState, useEffect } from 'react';
import { FaBell, FaTimes } from 'react-icons/fa';
import styles from './notificationPrompt.module.css';

const NotificationPrompt = ({ onSubscribe, onCancel }) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.container}>

                <div className={styles.iconBox}>
                    <FaBell className={styles.icon} />
                </div>
                <h3 className={styles.title}>
                  {Notification.permission === 'denied' ? 'Notifications bloquées' : 'Engagement requis'}
                </h3>
                <p className={styles.text}>
                  {Notification.permission === 'denied' 
                    ? "Vous avez bloqué les notifications dans votre navigateur. Pour continuer à utiliser Agora, veuillez les réactiver dans les paramètres du site (icône cadenas à gauche de l'URL)."
                    : "Abonnez-vous aux notifications pour continuer. Vous recevrez des alertes en temps réel quand quelqu'un s'intéresse à vos articles ou vous envoie un message."
                  }
                </p>
                <div className={styles.actions}>
                  <button className={styles.subscribeBtn} onClick={onSubscribe}>
                    {Notification.permission === 'denied' ? "J'ai compris" : "S'abonner aux notifications"}
                  </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationPrompt;
